// extracted by mini-css-extract-plugin
module.exports = {"device-text":"QuestionPreview_device-text__2W357","inline-math":"QuestionPreview_inline-math__2LJew"};